import { Theme } from '@mui/material/styles';
import { isLightTheme } from 'lib/themes/theme';
import darkColors from 'lib/themes/dark-colors.module.scss';

const { reportLightGrey, reportDarkGrey } = darkColors;

export const styles = (theme: Theme) => ({
  container: {
    padding: theme.spacing(3),
    backgroundColor: isLightTheme() ? theme.palette.background.paper : reportLightGrey,
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
  },
  tableContainer: {
    overflowX: 'auto',
    border: '1px solid #f0f0f0',
    borderRadius: 0,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse' as const,
    backgroundColor: isLightTheme() ? theme.palette.background.paper : reportLightGrey,
    tableLayout: 'fixed' as const,
  },
  headerCell: {
    'padding': theme.spacing(2),
    'textAlign': 'center' as const,
    'fontWeight': 600,
    'borderBottom': '1px solid #f0f0f0',
    'borderRight': '1px solid #f0f0f0',
    'backgroundColor': isLightTheme() ? 'rgb(237, 237, 237)' : reportDarkGrey,
    'fontSize': '0.875rem',
    'whiteSpace': 'nowrap' as const,
    '&:first-of-type': {
      textAlign: 'left' as const,
      width: '30%',
    },
  },
  cell: {
    padding: theme.spacing(2),
    borderTop: '1px solid #f0f0f0',
    borderRight: '1px solid #f0f0f0',
    fontSize: '0.875rem',
    verticalAlign: 'middle' as const,
  },
  cellNumber: {
    padding: theme.spacing(2),
    borderTop: '1px solid #f0f0f0',
    borderRight: '1px solid #f0f0f0',
    textAlign: 'center' as const,
    fontSize: '0.875rem',
    verticalAlign: 'middle' as const,
  },
  cellBold: {
    padding: theme.spacing(2),
    borderTop: '1px solid #f0f0f0',
    borderRight: '1px solid #f0f0f0',
    fontWeight: 600,
    fontSize: '0.875rem',
    verticalAlign: 'middle' as const,
  },
  cellNumberBold: {
    padding: theme.spacing(2),
    borderTop: '1px solid #f0f0f0',
    borderRight: '1px solid #f0f0f0',
    textAlign: 'center' as const,
    fontWeight: 600,
    fontSize: '0.875rem',
    verticalAlign: 'middle' as const,
  },
  dataRow: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  evenRow: {
    'backgroundColor': isLightTheme() ? 'rgb(237, 237, 237)' : '#1f2226',
    '& td': {
      backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : '#1f2226 !important',
    },
  },
  oddRow: {
    'backgroundColor': isLightTheme() ? theme.palette.background.paper : reportLightGrey,
    '& td': {
      backgroundColor: isLightTheme()
        ? theme.palette.background.paper
        : `${reportLightGrey} !important`,
    },
  },
  totalRow: {
    'backgroundColor': isLightTheme() ? 'rgb(237, 237, 237)' : reportDarkGrey,
    'fontWeight': 600,
    '& td': {
      fontWeight: 600,
      backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : `${reportDarkGrey} !important`,
    },
  },
  totalCell: {
    padding: theme.spacing(2),
    borderTop: '1px solid #f0f0f0',
    borderRight: '1px solid #f0f0f0',
    fontWeight: 600,
    fontSize: '0.875rem',
    verticalAlign: 'middle' as const,
    backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : `${reportDarkGrey} !important`,
  },
  totalCellNumber: {
    padding: theme.spacing(2),
    borderTop: '1px solid #f0f0f0',
    borderRight: '1px solid #f0f0f0',
    textAlign: 'center' as const,
    fontWeight: 600,
    fontSize: '0.875rem',
    verticalAlign: 'middle' as const,
    backgroundColor: isLightTheme() ? 'rgb(237, 237, 237)' : `${reportDarkGrey} !important`,
  },
  noData: {
    padding: theme.spacing(4),
    textAlign: 'center' as const,
    color: theme.palette.text.secondary,
  },
  filterLabel: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0.5),
    display: 'block',
  },
  filterChip: {
    margin: '2px 4px 2px 0',
  },
});
